import * as React from 'react';
import { zIndexVoxel } from '../../../logic/zIndexVoxel';

export interface VoxelVerticalDrawerProps {
  open?: boolean;
  closedWidthClass?: string;
  closedMinWidthClass?: string;
  openWidthClass?: string;
  openMinWidthClass?: string;
  shadowClass?: string;
  bgColorClass?: string;
  zIndexClass?: string;
}

const VoxelVerticalDrawer: React.FC<VoxelVerticalDrawerProps> = ({
  children,
  open,
  closedWidthClass = 'w-0',
  closedMinWidthClass = 'min-w-0',
  openWidthClass = 'w-96',
  openMinWidthClass = 'min-w-96',
  shadowClass = 'shadow-lg',
  bgColorClass = 'bg-voxel-gray-50',
  zIndexClass = zIndexVoxel.drawer,
}) => {

  const closedWidthString = `${closedWidthClass} ${closedMinWidthClass}`;
  const openWidthString = `${openWidthClass} ${openMinWidthClass}`

  return (
    <>
      {/* Spacer for the layout - so the content on the right side is sized correctly*/}
      <div className={`${open ? openWidthString : closedWidthString}`} />
      {/* The actual drawer is fixed to lock it vertically while scrolling */}
      <div className={`
      fixed h-full 
      ${open ? openWidthClass : closedWidthClass}
      ${zIndexClass} 
      ${shadowClass} 
      ${bgColorClass}
      border-r 
      `}
      >
        {children}
      </div>
    </>
  );
};

export default VoxelVerticalDrawer;
